import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "testing-for-edge-cases"
    }}>{`Testing for edge cases`}</h1>
    <p>{`Edge cases may affect the performance of your add-on.`}</p>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`As well as checking for more expected errors, you must also take the time to search for edge cases that may affect the performance of your add-on.`}</p>
    <p>{`This includes checking for boundary values or extreme scenarios that may cause issues when your add-on is in general use.`}</p>
    <h2 {...{
      "id": "handling-inputs"
    }}>{`Handling inputs`}</h2>
    <p>{`Ensure that your add-on can handle edge cases such as empty inputs, long inputs or inputs with special characters.`}</p>
    <h2 {...{
      "id": "boundary-values"
    }}>{`Boundary values`}</h2>
    <p>{`Your add-on should also be able to handle boundary values such as minimum or maximum allowed values without any unexpected behavior.`}</p>
    <h2 {...{
      "id": "extreme-scenarios"
    }}>{`Extreme scenarios`}</h2>
    <p>{`Your add-on should be able to cope with extreme situations such as low system resources, poor network conditions, or unexpected interruptions.`}</p>
    <h2 {...{
      "id": "tab-navigation"
    }}>{`Tab navigation`}</h2>
    <p>{`Users often use tab navigation to make their way through websites and applications. This is particularly true of users with disabilities who rely on keyboard navigation.`}</p>
    <p>{`Please ensure that add-ons do not interfere with - or override - tab navigation.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      